import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CrowdinOtaService } from 'src/app/services/crowdin-ota/crowdin-ota.service';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent implements OnInit {
  isNotFound: boolean = false;
  globalLang: string = 'en-GB';
  translationsArray: any;
  content: string = 'CP_PRIVACY_TEMPLATE';
  isTranslationDone: boolean = false;

  constructor(private readonly _translationService: TranslationService, 
    private readonly _actRoute: ActivatedRoute, 
    private readonly _crowdinService: CrowdinOtaService,
    private readonly languageService: LanguageService) { 
    const langId = this.languageService.getLanguage();
    const userLang = navigator.language;
    if (!langId || !this.languageService.checkIsValideLanguage(langId)) {
      this.isNotFound = true;
    } else {
      this.isNotFound = false;
      this.globalLang = langId && this.languageService.checkIsValideLanguage(langId) ? langId : 
      (userLang && this.languageService.checkIsValideLanguage(userLang) ? userLang : 'en-GB');
    }
  }

  ngOnInit(): void {
    this.content = 'CP_PRIVACY_TEMPLATE';
    const languageCode = this.globalLang.split('-')[0];
    this._crowdinService.useLanguage(languageCode);
  }

}
